// @ts-check

import React, { forwardRef, useEffect, useState } from "react"
import useReportFiltersContext from "../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import ClientTasksTableController from "./table/ClientTasksTable.controller"
import { useClientTasksTableData } from "./table/useClientTasksTableData.hook"
import { getDoesClientHasMultipleProjects } from "../../../../services/client.service"

/**
 * @type {React.ForwardRefExoticComponent<
 *   import("./ClientTasksColumnContent.controller.types").ClientTasksColumnContentProps &
 *   React.RefAttributes<import("./table/ClientTasksTable.controller.types").ClientTasksReportTableControllerRef>
 * >}
 */
const ClientTasksColumnContent = forwardRef((props, ref) => {
  const {
    contextMenuRef,
    setContextMenuTarget,
    updatingTask,
    selectedPeriod,
    onRowCountChange,
    clientHasValidSprint,
    periodType,
  } = props

  const [clientHasMultipleProjects, setClientHasMultipleProjects] =
    useState(false)

  const { clientReportSelectedClientCode } = useReportFiltersContext()

  /** @param {string} clientId */
  async function checkIfClientHasMultipleProjects(clientId) {
    if (!clientId) return

    const response = await getDoesClientHasMultipleProjects(clientId)

    if (response.success) {
      setClientHasMultipleProjects(response.result ?? false)
    }
  }

  useEffect(() => {
    if (!clientReportSelectedClientCode) return

    checkIfClientHasMultipleProjects(clientReportSelectedClientCode)
  }, [clientReportSelectedClientCode])

  const {
    tasks,
    categories,
    modules,
    projects,
    teamMembers,
    isLoading,
    refreshData,
  } = useClientTasksTableData({
    clientId: clientReportSelectedClientCode,
    dateRange: selectedPeriod,
    clientHasValidSprint,
    periodType,
  })

  return (
    <ClientTasksTableController
      ref={ref}
      value={tasks}
      contextMenuRef={contextMenuRef}
      setContextMenuTarget={setContextMenuTarget}
      updatingTask={updatingTask}
      categories={categories}
      modules={modules}
      projects={projects}
      teamMembers={teamMembers}
      isLoading={isLoading}
      onRowCountChange={onRowCountChange}
      refreshData={refreshData}
      hasMultipleProjects={clientHasMultipleProjects}
    />
  )
})

export default ClientTasksColumnContent
